import Auth from '../../modules/Authentication'
import { handleErrors, handleResponse } from '../../modules/Utils'
import { apiUrl } from '../../variables/index'

const headers = {}

export default class Statements {
  auth = new Auth()
  list = owner => {
    const select = '*'
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements?select=${select}`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
  read = key => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements/${key}`, { headers })
      .then(handleErrors)
      .then(handleResponse)
  }
  create = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements/`, {
      headers,
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  update = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements/`, {
      headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  operation = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements/action`, {
      headers: headers,
      method: 'PATCH',
      body: JSON.stringify(data),
    })
      .then(handleErrors)
      .then(handleResponse)
  }
  remove = data => {
    headers['authorization'] = `Bearer ${this.auth.getAccessToken()}`
    return fetch(`${apiUrl}statements/`, {
      headers,
      method: 'DELETE',
      body: JSON.stringify(data),
    }).then(handleErrors)
  }
}
